<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="app" :class="vueAppClasses" v-if="!$store.state.isLoading">
        <router-view @setAppClasses="setAppClasses" :key="$route.fullPath" :class="`route-${$route.name}`"/>
        <MobileDisabled v-if="$route.name && !$route.meta.mobileEnabled"/>
    </div>
</template>

<script>
    import themeConfig from '@/../themeConfig.js'
    import MobileDisabled from "@/components/MobileDisabled.vue";

    export default {
      components: {MobileDisabled},
        data() {
            return {
                vueAppClasses: [],
            }
        },
        watch: {
            '$store.state.theme'(val) {
                this.toggleClassInBody(val)
            },
            '$vs.rtl'(val) {
                document.documentElement.setAttribute("dir", val ? "rtl" : "ltr")
            },
            $route(v) {
              console.log(v)
            }
        },
        methods: {
            addLoading(container, background, color) {
                setTimeout(() => {
                    document.querySelectorAll(container).forEach(item => {
                        item.classList.add("loading-pen");
                        item.parentNode.classList.add("loading-pen");
                        this.$vs.loading({
                            background: background ? background : 'primary',
                            color: color ? color : '#fff',
                            container: item,
                            scale: 0.45
                        })
                    })
                }, 10)
            },
            removeLoading(container) {
                this.$vs.loading.close(container + " > .con-vs-loading")

                document.querySelectorAll(container).forEach(item => {
                    item.classList.remove("loading-pen");
                    item.parentNode.classList.remove("loading-pen");
                })
            },
            toggleClassInBody(className) {
                if (className == 'dark') {
                    if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
                    document.body.classList.add('theme-dark')
                } else if (className == 'semi-dark') {
                    if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
                    document.body.classList.add('theme-semi-dark')
                } else {
                    if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
                    if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
                }
            },
            setAppClasses(classesStr) {
                this.vueAppClasses.push(classesStr)
            },
            handleWindowResize() {
                this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

                // Set --vh property
                document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
            },
            handleScroll() {
                this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
            },
            getDefaultThumbnail(t) {
                let type = t ? t.toLowerCase() : t;
                let img = '/default-thumbs/';
                if (type === 'video' || type === 'animation') {
                    img += 'video.svg'
                } else if (type === 'audio') {
                    img += 'audio.svg'
                } else if (type === '3d') {
                    img += '3d.svg'
                } else {
                    img += 'image.svg'
                }
                return img;
            },
            handleSupportWebp() {
                const elem = document.createElement('canvas');

                if (elem.getContext && elem.getContext('2d')) {
                    this.$store.commit("setState", {supportWebp: elem.toDataURL('image/webp').indexOf('data:image/webp') === 0});
                }
            }
        },
        mounted() {
            console.log("APP MOUNTED");
            console.log(this.$route);
            window.topexy = this.$vs;
            this.$root.addLoading = this.addLoading.bind(this);
            this.$root.removeLoading = this.removeLoading.bind(this);
            this.$root.getDefaultThumbnail = this.getDefaultThumbnail.bind(this);
            this.toggleClassInBody(themeConfig.theme);
            this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
            this.handleSupportWebp();
            this.$vs.notifyWrapper = (params) => {
              let p = Object.assign(params, {time: 5000});
              if (p.fixed) {
                delete p.fixed;
              }
              this.$vs.notify(p);
              this.$root.$emit('notify');
            }

            let vh = window.innerHeight * 0.01;
            // Then we set the value in the --vh custom property to the root of the document
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        },
        async created() {

            let dir = this.$vs.rtl ? "rtl" : "ltr"
            document.documentElement.setAttribute("dir", dir)

            window.addEventListener('resize', this.handleWindowResize)
            window.addEventListener('scroll', this.handleScroll)

        },
        destroyed() {
            window.removeEventListener('resize', this.handleWindowResize)
            window.removeEventListener('scroll', this.handleScroll)
        },
    }

</script>
